import { useEffect } from 'react';
import { useReceiveMessage } from '../../context/messageContext';
import { useTestContext } from '../../context/testContext';
import { testsMap } from '../../helpers/data';
import { SelectTest, Logmar, RandomE, ICNVision, ContrastSensitivity, VisualField, NeuroSuite, Refraction, KaysOptotypes, ColourVision } from '.';

const Tests = ({ setActiveTab, setTitle }) => {
  const {
    updateTestData,
    testData: { testKey },
  } = useTestContext();
  const acuityTestComponents = {
    Logmar,
    RandomE,
    ICNVision,
    ContrastSensitivity,
    VisualField,
    NeuroSuite,
    Refraction,
    KaysOptotypes,
    ColourVision,
  };
  let TestComponent = acuityTestComponents[testsMap[testKey]?.['reactComponent']];
  const receivedMessage = useReceiveMessage();

  useEffect(() => {
    if (receivedMessage?.type === 'testNavigationReset') {
      updateTestData({ testKey: null });
    }
  }, [receivedMessage, updateTestData]);

  return !testKey ? (
    <SelectTest setActiveTab={setActiveTab} setTitle={setTitle} />
  ) : (
    <TestComponent setActiveTab={setActiveTab} setTitle={setTitle} />
  );
};

export default Tests;
